const categoriesList = [
    {
        "id": 1,
        "name": "Tin Tức"
    },
    {
        "id": 2,
        "name": "Thông tin cuộc thi"
    },
    {
        "id": 3,
        "name": "Đơn vị dự thi"
    },
    {
        "id": 4,
        "name": "Bản đồ thực tế ảo"
    },
    {
        "id": 5,
        "name": "Ý tưởng quy hoạch"
    }
]

export default categoriesList;